<template>
  <d-container fluid class="px-4">
    <!-- Page Header -->
    <div class="form-control visits__filter">
      <validation-provider
        name="parent_id"
        v-slot="{ errors }">
        <label for="parent_id">{{label}}</label>
        <div :class="{ 'form-control': true, 'is-select': true }">
          <v-select
            :options="data"
            :reduce="obj => obj.id"
            v-model="filter"
            :filterBy="filterByUsers"
            :placeholder="placeholder"
            label="id">
            <template slot="option" slot-scope="option" v-if="option.role !== 'R_HR'">
              <div class="d-center">
                {{ option.name }}
              </div>
            </template>
            <template slot="selected-option" slot-scope="option" v-if="option.role !== 'R_HR'">
              <div class="selected d-center">
                {{ option.name }}
              </div>
            </template>
          </v-select>
        </div>
        <div class="invalid-feedback">
          {{ errors[0] }}
        </div>
      </validation-provider>
    </div>
  </d-container>
</template>

<script>
import FormUtils from './../../utils/FormUtils.js';
import DatePicker from 'vue2-datepicker';

export default {
  name: 'visitsCalendar',
  components: {
    DatePicker
  },
  data () {
    return {
      data: [],
      filter: ''
    }
  },
  props: {
    label: {
      type: String,
      required: true
    },
    endpoint: {
      type: String,
      required: true
    },
    placeholder: {
      type: String,
      required: true
    }
  },
  mounted () {
    this.getList();
  },
  watch: {
    filter(data) {
      this.emitFilterResult(data);
    }
  },
  methods: {
    emitFilterResult(data) {
      this.$emit('input', data)
    },
    getList () {
      FormUtils.loadAdditionalData(this, {
        endpoint: this.endpoint,
        outputKey: 'data',
        params: {
          pagination: false
        },
      });
    },
    filterByUsers (option, label, search) {
      return (option.name + ' ' + option.last_name).toLowerCase().indexOf(search.toLowerCase()) > -1;
    }
  }
};
</script>

<style lang="scss" scoped>
  @import '../../assets/scss/visits-calendar.scss';
</style>

